<template>
    <div class="dashboard__section">
        <h2 class="dashboard__heading">
            <strong>{{units.length}}</strong>
            {{units.length | inflection(['aktivní jednotka', 'aktivní jednotky', 'aktivních jednotek'])}}
        </h2>
        <div class="dashboard__content">
            <div class="form__row dashboard__search">
                <div class="form__item">
                    <label for="unit">Vyhledat jednotku</label>
                    <input type="text" id="unit" v-model="search">
                </div>
            </div>

            <ul class="dashboard__list">
                <li class="dashboard__item dashboard__item--with-controls" v-for="unit in filteredUnits">
                    <div class="dashboard__label"><strong>{{unit.designation}}</strong></div>
                    <div class="dashboard__controls">
                        <custom-button @click="update(unit)" iconic><span icon edit></span>rychlá úprava</custom-button>
                        |
                        <router-link :to="{ name: 'project-unit-detail', params: {unitId: unit.id}}" class="text--maroon">
                            zobrazit
                        </router-link>
                    </div>
                </li>
            </ul>

            <router-link :to="{ name: 'project-unit-default'}" class="text--maroon">
                <strong>Přejít na výpis jednotek</strong>
            </router-link>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import UnitQuickUpdateDialog from '@/modules/ProjectModule/components/Dashboard/UnitQuickUpdateDialog';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    components: { CustomButton },
    computed:   {
        ...mapGetters('projects/project/units', ['units']),
        filteredUnits() {
            if (this.search.length === 0) {
                return [];
            }
            return this.units.filter(({ designation }) => {
                return designation.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            })
        }
    },
    data() {
        return {
            search: '',
        }
    },
    mounted() {
        this.loadUnits();
    },
    methods:    {
        ...mapActions('projects/project/units', ['loadUnits']),
        update(unit) {
            this.$modal.show(UnitQuickUpdateDialog, { id: unit.id }, defaultModalParameters());
        }
    }
}
</script>
